import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Form, Row, Spin } from 'antd';
import axios from 'axios';
import { axiosErrorHandler, isConcurrentModificationError, showSuccessNotification } from '../../../../../swzutils';
import RetailExpressSettings from "./integrations/RetailExpressSettings";
import IcsSettings from "./integrations/IcsSettings";
const TabIntegrations = ({ tenantId }) => {
    const [form] = Form.useForm();
    const [showSpinner, setShowSpinner] = useState(false);
    const [integrations, setIntegrations] = useState(undefined);
    useEffect(() => {
        loadIntegrations();
    }, [tenantId]);
    const loadIntegrations = () => {
        setShowSpinner(true);
        axios.get(`/admin/v1/tenants/${tenantId}/integrations`)
            .then(response => setIntegrations(response.data))
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    const getRetailExpressFormFields = (formValues) => {
        if (!formValues.retailExpressActive) {
            // Setting this to null will trigger the server to delete all settings for retail express
            return null;
        }
        const apiKeyFieldDisabled = form.getFieldInstance("retailExpressApiKey").input.disabled;
        return {
            active: true,
            apiKey: apiKeyFieldDisabled ? null : formValues.retailExpressApiKey,
            freightType: formValues.retailExpressFreightType,
            deliveryInstructionsFrom: formValues.retailExpressDeliveryInstructionsFrom,
            errorEmailAddressCsv: formValues.retailExpressErrorEmailCsv
        };
    };
    const getIcsFormFields = (formValues) => {
        if (!formValues.icsActive) {
            // Setting this to null will trigger the server to delete all settings for ICS
            return null;
        }
        const apiKeyFieldDisabled = form.getFieldInstance("icsApiKey").input.disabled;
        return {
            active: true,
            apiKey: apiKeyFieldDisabled ? null : formValues.icsApiKey,
            baseUrl: formValues.icsBaseUrl,
            errorEmailAddressCsv: formValues.icsErrorEmailCsv
        };
    };
    const handleSubmit = (formValues) => {
        setShowSpinner(true);
        const request = {
            retailExpress: getRetailExpressFormFields(formValues),
            ics: getIcsFormFields(formValues),
        };
        axios.put(`/admin/v1/tenants/${tenantId}/integrations`, request)
            .then(response => {
            setIntegrations(response.data);
            showSuccessNotification('Integration settings successfully updated');
        }).catch((error) => {
            if (isConcurrentModificationError(error)) {
                loadIntegrations();
            }
            axiosErrorHandler(error);
        }).finally(() => setShowSpinner(false));
    };
    return (_jsx(Spin, { spinning: showSpinner, children: _jsxs(Form, { layout: "vertical", onFinish: handleSubmit, form: form, children: [integrations &&
                    _jsxs(Row, { gutter: 10, children: [_jsx(Col, { xs: 24, children: _jsx(RetailExpressSettings, { form: form, settings: integrations.retailExpress }) }), _jsx(Divider, {}), _jsx(Col, { xs: 24, children: _jsx(IcsSettings, { form: form, settings: integrations.ics }) })] }), _jsx("p", { children: "\u00A0" }), _jsx(Row, { gutter: 10, className: "no-margin", children: _jsx(Col, { xs: 12, md: 6, children: _jsx(Button, { htmlType: "submit", block: true, type: "default", size: "large", children: "Update" }) }) }), _jsx("p", { children: "\u00A0" })] }) }));
};
export default TabIntegrations;
